import styled, { css } from 'styled-components';
export const Wrapper = styled.div ``;
const BookingsWrapper = css `

`;
export const ActiveBookingsWrapper = styled.div `
`;
export const PastBookingsWrapper = styled.div `
  margin-top: 3rem;
  
  .form__title {
    margin-bottom: 1.5rem;
  }
`;
export default {
    Wrapper,
};
